import { Reservation } from '../../../types/Reservation';
import { ApiReservation } from '../queries/dtos/ApiReservation';

export function reservationAdapter(dto: ApiReservation): Reservation {
  return {
    external_id: dto.external_id,
    status: dto.status as Reservation['status'],
    total_amount: dto.total_amount,
    payment_intention: dto.payment_intention,
    event: {
      start: new Date(dto.event.start),
      end: new Date(dto.event.end)
    },
    created_at: new Date(dto.created_at),
    student: dto.student,
    teacher: dto.teacher,
    course: {
      external_id: dto.course.external_id,
      label: dto.course.name,
      institution: dto.course.institution
        ? { external_id: dto.course.institution.external_id, label: dto.course.institution.name }
        : undefined
    },
    rate: dto.rate ?? null,
    group: dto.group ?? null
  };
}
